module.exports = __webpack_public_path__ + "img/Couple-dependant.01610973.svg";